import { render, staticRenderFns } from "./AbkTimeAndPlaceBox.vue?vue&type=template&id=39e68042&scoped=true&"
import script from "./AbkTimeAndPlaceBox.vue?vue&type=script&lang=js&"
export * from "./AbkTimeAndPlaceBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkTimeAndPlaceBox.vue?vue&type=style&index=0&id=39e68042&scoped=true&lang=scss&"
import style1 from "./AbkTimeAndPlaceBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e68042",
  null
  
)

export default component.exports